import { LoadboardValue } from "@/components/dataPages/loadboard";
import { TranslatedText } from "@/components/common/text";

export const NotSpecifiedValue = () => {
    return (
        <LoadboardValue className="font-normal text-cm-p-text-secondary">
            <TranslatedText text="Not specified" />
        </LoadboardValue>
    );
};
